// AUTO-GENERATED GraphQL Builder for ReuploadCheck
import * as Builders from '../';
export class ReuploadCheckBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  checkType(){ return this.add('checkType'); }
  label(){ return this.add('label'); }
  reason(){ return this.add('reason'); }
  referenceValue(){ return this.add('referenceValue'); }
}
